<template>
  <div>
    <a-modal title="批量开票" v-model="visible" width="80%" @cancel="close" destroyOnClose>
      <a-form-model v-if="!isShow.length" class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 13 }">
        <a-form-model-item label="导入祺信开立信息" prop="">
          <!--                    <a-button class="search-btn-item" type="primary">导入</a-button>-->
          <div class="spaceLeft page-main no-shadow">
            文件名称：
            <div class="file-item ellipsis">{{ fileList[0] && fileList[0].name }}</div>
            <a-upload :file-list="fileList" :before-upload="beforeFileUpload" :showUploadList="false">
              <a-button class="btn-blue-line" style="margin-left:20px;">选择文件 </a-button>
            </a-upload>
            <a-button type="primary" @click="handleFileUpload" :disabled="fileList.length === 0" :loading="uploading"
              style="margin-left:20px">导入</a-button>
            <a href="/static/templates/批量开立祺信模板.xlsx" download="批量开立祺信模板.xlsx" class="down-text">批量开立祺信模板.xlsx</a>
          </div>

        </a-form-model-item>
        <a-form-model-item label="导入凭证" prop="fileId">
          <div style="position:relative">
            <fileUpload url="/gb-bigtree-file/zipFileUpload" accept=".ZIP,.zip" ref="fileUpload" :paramObj="uploadParam"
              @handleFileRemove="removeOk" :removeaction="true" name="file" :autoSave='false' @uploadOkZip="uploadOkZip"
              @uploadOkCopy='uploadOkCopy' />
            <div class="text-color-orange img-tip">
              温馨提示：支持ZIP格式，单个附件大小不可超过100M。附件内文件命名规则：申请编号+三位序号+自主命名，例如申请编号002-对账单、申请编号005祺信申请书</div>
          </div>
        </a-form-model-item>
      </a-form-model>
      <div v-else>
        <a-table size="middle" :columns="invoiceColumns" :row-key="record => record.id" :data-source="isShow"
          :bordered="true" :pagination="false" :locale="{ emptyText: '暂无数据' }">
          <template slot="openedAmount" slot-scope="text, record">
            {{ openedAmount(record) }}
          </template>
        </a-table>
        <a-form-model class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData"
          :label-col="{ span: 4 }" :wrapper-col="{ span: 13 }">
          <a-form-model-item label="导入祺信开立信息" prop="">
            <div class="file-item ellipsis">{{ fileList[0] && fileList[0].name }}</div>
            <a-upload :file-list="fileList" :before-upload="beforeFileUpload" :showUploadList="false">
              <a-button class="btn-blue-line" style="margin-left:20px;">选择文件 </a-button>
            </a-upload>
            <a-button type="primary" @click="handleFileUpload" :disabled="fileList.length === 0" :loading="uploading"
              style="margin-left:20px">导入</a-button>
            <a href="/static/templates/批量开立祺信模板-有发票.xlsx" download="批量开立祺信模板-有发票.xlsx"
              class="down-text">批量开立祺信模板-有发票.xlsx</a>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="common-title">待开立列表</div>
      <div class="common-table-box">
        <a-table :columns="columns" :dataSource="tableData" :pagination="false" :rowKey="record => record.id"
          :bordered="true" :loading="loading">
          <template slot="startDay" slot-scope="text">
            {{ text | dateFormat("YYYY-mm-dd") }}
          </template>
          <template slot="exDay" slot-scope="text">
            {{ text | dateFormat("YYYY-mm-dd") }}
          </template>
          <template slot="canBeModified" slot-scope="text">
            {{ text == '1' ? '可变更' : text == '0' ? '不可变更' : '' }}

          </template>
          <template slot="fileIds" slot-scope="text, record">
            {{ record.fileNm }}

          </template>
          <template slot="operate" slot-scope="text, record">
            <a v-if="!isShow.length" @click='edit(record)'>编辑</a>
            <a v-else @click='chooseFile(record)'>选择附件</a>
            <a @click='del(record)'>删除</a>

          </template>
        </a-table>
        <div style="margin-top: 15px;" :class="{
          'table-total': pagination.total > 0,
          'table-total-none': pagination.total == 0
        }">
          记录：
          <span class="text-color-blue"> {{ tableData.length }} 条 </span>
          开立总额(元)：
          <span class="text-color-orange">
            {{ totalPayable(tableData) | splitK }} 元
          </span>
        </div>
        <div style="text-align: center;">
          <a-button :loading="importloading" class="search-btn-item" type="primary"
            @click="handleImportTableData">导入列表</a-button>
        </div>
      </div>
      <div class="common-title">批量开立列表</div>
      <div class="common-table-box">
        <a-table :columns="batchcolumns" :dataSource="batchData" :pagination="false" :rowKey="record => record.id"
          :bordered="true" :loading="loading">
          <template slot="fileIds" slot-scope="text, record">
            {{ record.fileNm }}
            <!-- <a @click='openFileTable(record)'>{{record.fileNm}}</a> -->
          </template>
          <template slot="startDay" slot-scope="text">
            {{ text | dateFormat("YYYY-mm-dd") }}
          </template>
          <template slot="exDay" slot-scope="text">
            {{ text | dateFormat("YYYY-mm-dd") }}
          </template>
          <template slot="canBeModified" slot-scope="text">
            {{ text == '1' ? '可变更' : text == '0' ? '不可变更' : '' }}

          </template>
          <template slot="operate" slot-scope="text, record">
            <a @click='openFile(record)'>付款承诺函</a>
            <a @click='delbath(record)'>删除</a>

          </template>
        </a-table>
        <div style="margin-top: 15px;" :class="{
          'table-total': pagination2.total > 0,
          'table-total-none': pagination2.total == 0
        }">
          记录：
          <span class="text-color-blue"> {{ batchData.length }} 条 </span>
          开立总额(元)：
          <span class="text-color-orange">
            {{ totalPayable(batchData) | splitK }} 元
          </span>
        </div>
      </div>
      <template slot="footer">
        <a-button class="btn-blue-line" @click="close()">取消</a-button>
        <!-- <button-load type="primary" lable="暂存" /> -->
        <button-load type="primary" @clickHandle="saveBatchData" lable="批量开立" />
      </template>
    </a-modal>
    <fileView :artcCntnt.sync="artcCntnt" ref="fileView" />
    <a-spin :spinning="loading">
      <a-modal v-model:open="otherOpen" :confirm-loading="false" on-ok="handleOk" width="900px"
        @cancel="handleotherCancel">
        <template slot="title">
          <div>编辑</div>
          <div style="font-size:12px;color:#B3B3B3;margin-top: 5px;">
            通过无发票开立的祺信，无法进行融资
          </div>
        </template>
        <a-form-model ref="rulesotherform" :model="otherform" :rules="rules" :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }">
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:320px" label="开立方" prop="estbName">
              <a-input style="width: 210px;" :disabled="true" v-model="otherform.estbName" />
            </a-form-model-item>
            <!-- <a-form-model-item style="width:245px" label="" prop="">
              <a-button primary @click="handlehistoryInfo">引入历史开票信息</a-button>
            </a-form-model-item> -->
          </div>
          <!-- <a-form-model-item prop="importType" :colon="false" style="margin-bottom:8px;margin-left:128px;width:320px">
            <a-radio-group name="importType" v-model="importData.importType">
              <a-radio v-for="item in importType" :value="item.value" :key="item.value" @click="hadleRadio(item.value)">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item> -->
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:320px" label="接收方" prop="rcPtyName">
              <select-search style="width: 210px;" v-model="importData.tenantObj" :searchSource="true"
                :dataSource="importOption" :other="true" headNameFirst="接收方名称" headNameSecond="社会信用代码"
                valuePorp="cstOrgCode" labelPorp="cstNm" @handleChange="changeTenant"
                @handleSearch="handleSearchImport"></select-search>
            </a-form-model-item>
            <a-form-model-item style="width:465px" label="社会信用代码" prop="cstOrgCode">
              <a-input style="width: 210px;" v-model="otherform.cstOrgCode" disabled />
            </a-form-model-item>
          </div>
          <!-- <div style="display:flex;justify-content: space-between;" v-if="importData.importType == 2">
            <div>
              <a-form-model-item style="width:320px;" label="接收方" prop="tenantName2">
                <select-search style="width: 210px;" v-model="importData2.tenantObj" :searchSource="true" :dataSource="importOption" :other="true"
                               headNameFirst="接收方名称" headNameSecond="社会信用代码" valuePorp="orgCode" labelPorp="userName" @handleChange="changeTenantJR"
                               @handleSearch="handleBlur"></select-search>
              </a-form-model-item>
              <a-form-model-item label="" style="margin-bottom:8px;margin-left:108px;width:250px;white-space: nowrap;" :colon="false"
                                 v-if="importErrText">
                <span class="text-color-red">{{ importErrText }}</span>
              </a-form-model-item>
            </div>
            <a-form-model-item style="width:465px" label="社会信用代码" prop="OrgCode">
              <a-input style="width: 210px;" v-model="otherform.OrgCode" disabled />
            </a-form-model-item>
          </div> -->
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:255px" label="开立金额" prop="gldAmt">
              <div class="spaceLeft" style="flex-wrap: nowrap;width:400px">
                <a-popover title="开立金额">
                  <template slot="content">
                    <p style="width:300px">
                      开立金额只能输入数字和小数点，整数不分最多支持10位，小数点后支持2位
                    </p>
                  </template>
                  <a-icon type="question-circle" class="common-question" />
                </a-popover>
                <div style="display: flex; align-items: center;">
                  <a-input-number style="width: 210px;" v-model="otherform.gldAmt" placeholder="请输入" :min="0"
                    :max="9999999999.99" :precision="2" />
                  <!-- <a-input />元 -->
                </div>
              </div>
            </a-form-model-item>

            <a-form-model-item style="width:465px" label="兑付日期" prop="exDay">
              <a-date-picker style="width: 210px;" valueFormat="YYYY-MM-DD" v-model="otherform.exDay" placeholder="请选择"
                :disabled-date="disabledDate1" />
            </a-form-model-item>
          </div>
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:320px" label="是否可变更" prop="canBeModified">
              <a-select v-model="otherform.canBeModified" :allowClear="true" option-label-prop="label"
                style="width:210px">
                <a-select-option v-for="item in canBeModifiedList" :key="item.value" :value="item.value"
                  :label="item.name">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="罚息利率：" prop="overdueRateVal " style="width:500px" :rules="[
              {
                required: true,
                whitespace: true,
                validator: overdueRateCheck1
              }
            ]">
              <div class="spaceLeft" style="flex-wrap: nowrap;width:400px">
                <a-popover title="罚息利率：">
                  <template slot="content">
                    <p style="width:300px">
                      若勾选1年期LRP，系统将自动转化为日利率。（日利率=年利率/360，日利率保留四位小数，第四位小数加1）
                    </p>
                  </template>
                  <a-icon type="question-circle" class="common-question" />
                </a-popover>
                <div style="width:150px">
                  <a-input :disabled="isLRP1" v-model="otherform.overdueRateVal" placeholder="请输入" suffix="日利率(%)" />
                </div>
                <a-checkbox v-model="isLRP1" style="margin-left:10px;" v-if="LRP">1年期LPR({{ LRP }}%)</a-checkbox>
              </div>
            </a-form-model-item>
          </div>
          <div>
            <otherFileUpload ref="childFileUpload" :introducedSource='introducedSource' @batchOpening="batchOpening"
              @receiveFileTblBlId="receiveFileTblBlId"></otherFileUpload>
          </div>
        </a-form-model>

        <template slot="footer">
          <a-button @click="handleotherCancel">
            关闭
          </a-button>
          <a-button type="primary" :loading="loading" @click="handleOk">
            确定
          </a-button>
        </template>
      </a-modal>
      <a-modal v-model:open="fileTableVisible" title="附件查看" :confirm-loading="false" width="900px"
        @cancel="fileTableVisible = false">
        <a-table :columns="fileColumns" :dataSource="fileTableData" :pagination='false' :rowKey="record => record.id"
          :bordered="true">
          <template slot="sort" slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
          <template slot="fileNm" slot-scope="text, record">

            <a @click="handlePreview(record)">{{ text }}</a>

          </template>
          <template slot="operate" slot-scope="text, record">

            <a @click='down(record)'>下载</a>

          </template>
        </a-table>
        <template slot="footer">
          <a-button @click="fileTableVisible = false">
            关闭
          </a-button>

        </template>
      </a-modal>
      <fileView :artcCntnt.sync="artcCntnt" ref="fileView" />
    </a-spin>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="预览图片" style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal v-model="pdfVisible" title="PDF 预览" width="80%" :footer="null">
      <div ref="pdfContainer" style="height: 70vh; overflow: auto;"></div>
    </a-modal>
    <!-- 履约凭证 -->
    <a-modal v-model="fulfilVisible" title="履约凭证" width="60%" @cancel="fulfilclose" destroyOnClose>
      <a-form-model class="common-form-inline" :rules="fulfilForm" ref="fulfilForm" :model="fulfilData"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 13 }">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="凭证类型" prop="documentType">
              <a-radio-group v-model="fulfilData.documentType">
                <a-radio v-for="item in VoucherDocumentTypeList" :key="item.dctVal" :value="item.dctVal">{{
                  item.dctValNm }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="凭证编号" prop="voucherCode">
              <a-input v-model="fulfilData.voucherCode" @blur="getTableList" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="table-common common">
        <a-table :loading="tableLoading" size="middle" :columns="fulfilcolumns" :row-key="record => record.id"
          :data-source="fulfiltableData" :pagination="false" bordered :locale="{ emptyText: '暂无数据' }"
          :row-selection="tableSelect">
          <template slot="gldId" slot-scope="text">
            <span @click='toGldDetail'>{{ text }}</span> </template>
          <template slot="name" slot-scope="text,record">
            <a style="width:180px" type="link" @click="lookFile(record)">{{ text || record.file.fileNm }}</a>
          </template>
          <template slot="documentType" slot-scope="text">{{ text |
            dictFilter(VoucherDocumentTypeList) }}</template>
          <template slot="createTime" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
          <template slot="oper" slot-scope="text,record,index">
            <a @click="downloadFile(record.file)">下载</a>
          </template>
        </a-table>
      </div>
      <template slot="footer">
        <a-button @click="fulfilclose">
          关闭
        </a-button>
        <a-button type="primary" :loading="loading" @click="handlefulfilOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { fileSaveAPI } from '@/api/file.js';
import fileView from '@/components/table-find-rcvb/fileView';
import { applyGoldApi, getParamByKey, verifyTradePassword, getLetterofCommitment } from '@/api/gold.js';
import { invoiceList, invDelete, go2Check, go2PlatFormCheck, selectSellerCstByName, invoicegetVoucherList } from '@/api/payable.js';
import otherFileUpload from './other-file-upload';
import { circleQuery } from '@/api/circle.js';
import { queryByDate } from '@/api/center.js';
import { mapActions } from 'vuex';
export default {
  components: { fileView, otherFileUpload },
  props: {
    isShow: {
      type: Array,
      default: []
    }
  },
  data() {
    const validateEndDate = (rule, value, callback) => {
      const date = new Date(); // 当前时间
      const isoString = date.toISOString(); // "2025-05-15T00:00:00.000Z"
      const formattedDate = isoString.split('T')[0]; // "2025-05-15"
      if (Date.parse(this.otherform.exDay) < Date.parse(formattedDate)) {
        this.importErrText = '兑付日期需大于当前日期';
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    return {
      fileZipObj: {},
      pdfVisible: false,
      previewVisible: false,
      fileTableVisible: false,
      previewImage: null,
      importErrText: '',
      holDayMap: {}, //存放节假日日期，按年份分组
      importOption: [],
      isLRP1: false,
      LRP: 0.01,
      otherOpen: false,
      artcCntnt: '',
      visible: false,
      ruleForm: {},
      pageData: {},
      fileList: [],
      uploading: false,
      uploadParam: {
        app: 'portal-pc',
        module: 'payable',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'payable'
      },
      columns: [
        {
          title: '申请日期',
          dataIndex: 'startDay',
          scopedSlots: { customRender: 'startDay' },
          key: 'startDay'
        },
        {
          title: '申请编号',
          dataIndex: 'gldId',
          key: 'gldId'
        },
        {
          title: '开立方',
          dataIndex: 'estbName',
          key: 'estbName'
        },
        {
          title: '接收方',
          dataIndex: 'rcPtyName',
          key: 'rcPtyName'
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'sellrOrgCode'
        },
        {
          title: '祺信金额(元)',
          dataIndex: 'gldAmt'
        },
        {
          title: '到期日期',
          scopedSlots: { customRender: 'exDay' },
          dataIndex: 'exDay'
        },
        {
          title: '变更状态',
          dataIndex: 'canBeModified',
          scopedSlots: { customRender: 'canBeModified' }
        },
        {
          title: '罚息利率',
          dataIndex: 'overdueRateVal'
        },
        {
          title: '相关附件',
          dataIndex: 'fileIds',
          scopedSlots: { customRender: 'fileIds' }
        },
        // {
        //   title: '相关附件',
        //   dataIndex: 'fileNams',
        // },
        // {
        //   title: '相关附件',
        //   dataIndex: 'filePaths',
        // },
        {
          title: '操作',
          dataIndex: 'operate',
          width: '160px',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      invoiceColumns: [
        {
          title: '卖方名称',
          dataIndex: 'sellrName',
          key: 'sellrName'
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          key: 'contractNo'
        },
        {
          title: '发票金额(元)',
          dataIndex: 'invoiceAmountWithVat',
          key: 'invoiceAmountWithVat'
        },
        {
          title: '已开金额(元)',
          dataIndex: "openedAmount",
          scopedSlots: { customRender: "openedAmount" },
        },
        {
          title: '可开立余额(元)',
          dataIndex: 'canEstbGldBal'
        },
      ],
      fileTableData: [],
      fileColumns: [
        {
          title: '序号',
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' }
        },
        {
          title: '祺信编号',
          dataIndex: 'startDay',
          scopedSlots: { customRender: 'startDay' },
          key: 'startDay'
        },
        {
          title: '凭证名称',
          dataIndex: 'fileNm',
          scopedSlots: { customRender: 'fileNm' },
          key: 'fileNm'
        },
        {
          title: '凭证编号',
          dataIndex: 'estbName',
          key: 'estbName'
        },
        {
          title: '凭证类型',
          dataIndex: 'rcPtyName',
          key: 'rcPtyName'
        },
        {
          title: '上传人',
          dataIndex: 'sellrOrgCode'
        },
        {
          title: '上传日期',
          dataIndex: 'gldAmt'
        },

        {
          title: '操作',
          dataIndex: 'operate',
          width: '160px',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      batchcolumns: [
        {
          title: '申请日期',
          dataIndex: 'startDay',
          scopedSlots: { customRender: 'startDay' },
          key: 'startDay'
        },
        {
          title: '祺信编号',
          dataIndex: 'gldId',
          key: 'gldId'
        },
        {
          title: '开立方',
          dataIndex: 'estbName',
          key: 'estbName'
        },
        {
          title: '接收方',
          dataIndex: 'rcPtyName',
          key: 'rcPtyName'
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'sellrOrgCode'
        },
        {
          title: '祺信金额(元)',
          dataIndex: 'gldAmt'
        },
        {
          title: '到期日期',
          scopedSlots: { customRender: 'exDay' },
          dataIndex: 'exDay'
        },
        {
          title: '变更状态',
          dataIndex: 'canBeModified',
          scopedSlots: { customRender: 'canBeModified' }
        },
        {
          title: '罚息利率',
          dataIndex: 'overdueRateVal'
        },

        {
          title: '相关附件',
          dataIndex: 'fileIds',
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          title: '操作',
          width: '160px',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      tableData: [],
      batchData: [],
      loading: false,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showTotal: (total) => {
          return `共 ${total} 条`;
        }
      },
      pagination2: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showTotal: (total) => {
          return `共 ${total} 条`;
        }
      },
      otherform: {
        estbName: undefined,
        importType: undefined,
        rcPtyName: undefined,
        cstOrgCode: undefined,
        tenantName2: undefined,
        OrgCode: undefined,
        gldAmt: undefined,
        exDay: undefined,
        canBeModified: undefined,
        overdueRateVal: undefined
      },
      rules: {
        estbName: [{ required: true, message: '请填写开立方企业名称', trigger: 'blur' }],
        rcPtyName: [{ required: true, message: '请选择接收方企业名称', trigger: 'blur' }],
        gldAmt: [{ required: true, message: '请填写开立金额', trigger: 'blur' }],

        canBeModified: [{ required: true, message: '请选择是否变更', trigger: 'blur' }],
        // cstOrgCode: [{ required: true, message: '请填写社会信用代码', }],
        // OrgCode: [{ required: true, message: '请填写社会信用代码', }],
        // tenantName2: [{ required: true, message: '请填写接收方企业名称', trigger: 'blur' }],
        exDay: [
          { required: true, message: '请填写兑付日期', trigger: 'blur' },
          { validator: validateEndDate, trigger: 'change' }
        ]
      },
      importType: [
        { name: '圈子', value: '1' },
        { name: '键入', value: '2' }
      ],
      canBeModifiedList: [
        { name: '是', value: '1' },
        { name: '否', value: '0' }
      ],
      //  导入弹窗
      importData: {
        importType: '1',
        tenantName2: undefined, //键入值
        tenantObj: {
          cstNm: '',
          cstOrgCode: '',
          guaranteeCstId: ''
        }
      },
      importData2: {
        importType: '2',
        tenantName2: undefined, //键入值
        tenantObj: {}
      },
      introducedSource: [],
      fileIdsArr: [],
      fileListArr: [],
      fulfilVisible: false,
      fulfilForm: {},
      fulfilData: {},
      VoucherDocumentTypeList: [],
      fulfilcolumns: [
        {
          title: '祺信编号',
          dataIndex: 'gldId',
          scopedSlots: { customRender: 'gldId' }
        },
        {
          title: '凭证名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          width: 180
        },
        {
          title: '凭证类型',
          dataIndex: 'documentType',
          scopedSlots: { customRender: 'documentType' }
        },
        {
          title: '凭证编号',
          dataIndex: 'voucherCode'
        },
        {
          title: '上传人',
          dataIndex: 'createUser'
        },
        {
          title: '上传日期',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'oper',
          scopedSlots: { customRender: 'oper' },
          width: 240,
        }
      ],
      fulfiltableData: [],
      tableLoading: false,
      fulfilselectedRowKeys: [],
      fulfilselectedRows: [],
      rowData: {},
      importloading: false
    };
  },
  created() {
    this.getParamByKey();
    let year = new Date(new Date()).getFullYear();

    this.getHolDays(year), this.getHolDays(year + 1), this.getHolDays(year + 2);
    this.getDicAsync('VoucherDocumentType').then((res) => {
      this.VoucherDocumentTypeList = res;
    });
  },
  computed: {
    openedAmount() {
      return (record) => {
        const amount = record.invoiceAmountWithVat - record.canEstbGldBal;
        return amount > 0 ? amount.toFixed(2) : '0.00';
      }
    },
    tableSelect() {
      return {
        type: "checkbox",
        selectedRowKeys: this.fulfilselectedRowKeys,
        selectedRows: this.fulfilselectedRows,
        onSelectAll: this.onSelectAll,
        onSelect: this.onSelect,
      };
    },
  },
  name: 'invoice-info-dialog',
  methods: {
    ...mapActions({
      getDicAsync: 'app/getDicAsync'
    }),
    handleOk() {
      console.log('%c Line:461 🍩 this.otherform', 'color:#3f7cff', this.otherform);
      console.log('%c Line:461 🍩 this.fileListArr', 'color:#3f7cff', this.fileListArr);

      this.$refs.rulesotherform.validate((valid) => {
        if (valid) {
          this.otherOpen = false;
          this.loading = false;
          this.tableData.forEach((item, index) => {
            if (item.gldId == this.otherform.gldId) {
              let fileList = this.fileListArr || [];
              let data = {
                ...this.otherform,
                rcPtyName: this.importData.tenantObj.cstNm,
                sellrOrgCode: this.importData.tenantObj.cstOrgCode,
                rcPty: this.importData.tenantObj.guaranteeCstId,
                fileIds: this.fileIdsArr.join(',') || '',
                fileList: this.fileListArr || [],
                isLRP1: this.isLRP1,
                fileNm: (item.fileNm = fileList && fileList.length > 0 ? fileList.map((it) => it.fileNm).join(',') : '')
              };

              this.tableData.splice(index, 1, data);
            }
          });
          this.isLRP1 = false;
          this.$refs.childFileUpload.initData(); //重置上传附件数据
          console.log('%c Line:457 🍕', 'color:#e41a6a', this.tableData);
        } else {
          console.log('error submit!!');
          this.loading = false;
          return false;
        }
      });
    },
    // 获取节假日
    getHolDays(year) {
      if (year) {
        return new Promise((resolve, reject) => {
          queryByDate({
            date: year
          })
            .then((res) => {
              this.holDayMap[year] = res.data || [];
              resolve();
            })
            .catch((err) => {
              reject();
            });
        });
      }
    },
    // 卖方选项变化
    changeTenant(data, node) {
      console.log(data, node);

      this.importData.tenantNode = node;
      this.importData.tenantObj = node;
      this.importData.tenantObj = {
        cstNm: node.cstNm,
        label: node.cstNm,
        key: node.cstOrgCode,
        cstOrgCode: node.cstOrgCode,
        guaranteeCstId: node.guaranteeCstId
      };
      if (this.otherOpen == true) {
        this.otherform.rcPtyName = node.cstNm;
        this.otherform.cstOrgCode = node.cstOrgCode;
        this.otherform.rcPty = node.guaranteeCstId;
      }
    },
    // 导入弹窗选择卖方名称
    handleSearchImport(value, data) {
      circleQuery({
        cstNm: value,
        tab: 2,
        pageSize: 10,
        pageNum: 1
      })
        .then((res) => {
          this.importOption = res.data.grid.list;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 键入卖方选项变化
    changeTenantJR(data, node) {
      console.log(node, 123);

      this.importData2.tenantNode = node;
      if (this.otherOpen == true) {
        this.otherform.tenantName2 = node.userName;
        this.otherform.OrgCode = node.orgCode;
        this.otherform.rcPty = node.guaranteeCstId;
      }
    },
    handleBlur(value, data) {
      this.importErrText = '';

      selectSellerCstByName({
        userName: value,
        // tab: 2,
        pageSize: 10,
        pageNum: 1
      })
        .then((res) => {
          this.importOption = res.data.grid.list;
        })
        .catch((error) => {
          console.log(error);
          this.importErrText = error.description;
          this.otherform.OrgCode = '';
        });
    },
    getParamByKey() {
      getParamByKey({ paramName: 'base_interest_rate_lpr' }).then((res) => {
        this.LRP = res.data;
      });
    },
    receiveFileTblBlId(tblBlId) {
      console.log('%c Line:564 🍯 tblBlId', 'color:#93c0a4', this.introducedSource);
      this.otherform.tblBlId = tblBlId;
    },
    hadleRadio(type) {
      if (type == 1) {
        // this.otherform.tenantName2 = null
        this.otherform.OrgCode = null;
        this.importData2.tenantObj = {};
      }
      if (type == 2) {
        this.importData.tenantObj = {};
        this.otherform.cstOrgCode = null;
      }
    },
    handleotherCancel(e) {
      this.otherOpen = false;
      this.$refs.rulesotherform.resetFields();
    },
    //其他开立
    disabledDate1(cuurent) {
      // Can not select days before today and today
      // return current && current < moment().endOf('day');
      // 节假日
      let data_value = this.utils.getDate(cuurent, 'YYYY-mm-dd');
      const year = new Date(cuurent).getFullYear();
      if (this.isHolOrRest(year, data_value)) {
        return true;
      }

      // 小于t+10
      let today = undefined;
      let curDay = new Date(cuurent).getTime();

      // 此处为处理日期插件问题，无实际意义-开始
      if (this.otherform.exDay) {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      } else {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      }
      // 此处为处理日期插件问题-结束
      return today > curDay;
    },
    // 判断是否为休息日或者是节假日
    isHolOrRest(year, value) {
      const list = this.holDayMap[year] || [];
      const item = list.find((i) => i.holDt == value || i.holDt == value + ' 00:00:00');
      if (item) {
        return {
          ...item,
          result: true
        };
      } else {
        return null;
      }
    },
    openFile(record) {
      if (!this.isShow.length) {
        this.otherform.cstOrgCode = this.otherform.rcPty;
        this.otherform.rcPtyName = this.otherform.rcPtyName;
        const { gldAmt, exDay, rcPtyName, cstOrgCode } = this.otherform;
        const params = {
          cstName: rcPtyName,
          gldTAmt: gldAmt,
          exDat: exDay,
          rcPtyOrgCode: cstOrgCode,
          tenantId: this.$store.getters['home/getTenant'].tenantId,
          overdueRateVal: String(this.otherform.overdueRateVal)
        };
        if (gldAmt == null || exDay == null || rcPtyName == null || cstOrgCode == null) {
          return this.$message.warn('开立信息不全，请填写完整内容后再查看');
        }
        getLetterofCommitment(params)
          .then((res) => {
            this.artcCntnt = res.data;
            this.$refs.fileView.open();
          })
          .catch((err) => { });
      } else {
        const params = {
          gldId: record.gldId,
          cstName: record.rcPtyName,
          gldTAmt: record.gldAmt,
          exDat: record.exDay,
          rcPtyOrgCode: record.sellrOrgCode,
          tenantId: this.$store.getters['home/getTenant'].tenantId,
          overdueRateVal: String(record.overdueRateVal),
          goldRcvblList: JSON.stringify(record.goldRcvblList),
          estbOrgCode: record.estbOrgCode
        };
        if (params.gldTAmt == null || params.exDat == null || params.cstName == null || params.rcPtyOrgCode == null) {
          return this.$message.warn('开立信息不全，请填写完整内容后再查看');
        }
        getLetterofCommitment(params)
          .then((res) => {
            this.artcCntnt = res.data;
            this.$refs.fileView.open();
          })
          .catch((err) => { });
      }
    },
    del(record) {
      const self = this;
      this.$confirm({
        title: '提示',
        content: `您确定删除所选祺信吗`,
        cancelText: '取消',
        okText: '确定',
        maskClosable: true,
        onCancel() {
          return false;
        },
        onOk() {
          self.tableData = self.tableData.filter((item) => item.gldId !== record.gldId);
        }
      });
    },
    delbath(record) {
      const self = this;
      this.$confirm({
        title: '提示',
        content: `您确定删除所选祺信吗`,
        cancelText: '取消',
        okText: '确定',
        maskClosable: true,
        onCancel() {
          return false;
        },
        onOk() {
          self.batchData = self.batchData.filter((item) => item.gldId !== record.gldId);
        }
      });
    },
    edit(selectedRow) {
      this.introducedSource = [];
      console.log("%c Line:775 🥤 this.introducedSource", "color:#4fff4B", this.introducedSource);

      console.log('%c Line:996 🍭 selectedRow', 'color:#ea7e5c', selectedRow);
      // 将选中的行数据赋值到当前页面的字段
      this.importOption = [
        {
          cstNm: selectedRow.rcPtyName,
          cstOrgCode: selectedRow.sellrOrgCode,
          guaranteeCstId: selectedRow.rcPty
        }
      ];
      this.importData.tenantObj = {
        cstNm: selectedRow.rcPtyName,
        label: selectedRow.rcPtyName,
        key: selectedRow.sellrOrgCode,
        cstOrgCode: selectedRow.sellrOrgCode,
        guaranteeCstId: selectedRow.rcPty
      };
      console.log(this.importOption, this.importData.tenantObj, 123);
      this.otherform.rcPtyName = selectedRow.rcPtyName; // 接收方名称
      this.otherform.cstOrgCode = selectedRow.sellrOrgCode; // 社会信用代码
      this.otherform.gldAmt = selectedRow.gldAmt; // 开立金额
      this.otherform.exDay = selectedRow.exDay; // 兑付日期
      this.otherform.gldId = selectedRow.gldId; //
      this.otherform.startDay = selectedRow.startDay; //
      if (selectedRow.canBeModified == '1' || selectedRow.canBeModified == '0') {
        this.otherform.canBeModified = selectedRow.canBeModified; // 是否可变更
      }
      this.otherform.estbName = selectedRow.estbName; // 开立方
      this.otherform.overdueRateVal = selectedRow.overdueRateVal; // 罚息利率
      this.otherform.fileList = selectedRow.fileList
        ? selectedRow.fileList.map((it) => {
          it.fileOnlyFrontDel = true; //只在前端删除，不走删除接口
          return it;
        })
        : []; // 附件列表
      this.introducedSource = selectedRow.fileList ?[...selectedRow.fileList]  : []; // 附件列表
      console.log("%c Line:812 🥚 this.introducedSource", "color:#42b983", this.introducedSource);
      this.fileListArr = selectedRow.fileList ? [...selectedRow.fileList] : []; // 附件列表

      this.otherform.rcPty = selectedRow.rcPty; // 附件列表
      this.isLRP1 = selectedRow.isLRP1 ? true : false; //是否为LRP1
      // if (this.introducedSource && this.introducedSource.length > 0) {
      //   this.introducedSource.forEach((item) => {
      //     this.fileSave(item);
      //   });
      // }

      this.otherform = { ...this.otherform };
      this.$forceUpdate();
      this.otherOpen = true;
      this.$nextTick(() => {
        if (this.introducedSource.length == 0) {
          this.$refs.childFileUpload.initData(); //重置上传附件数据
        }
      });
    },

    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.otherform = {
        estbName: undefined,
        importType: undefined,
        rcPtyName: undefined,
        cstOrgCode: undefined,
        tenantName2: undefined,
        OrgCode: undefined,
        gldAmt: undefined,
        exDay: undefined,
        canBeModified: undefined,
        overdueRateVal: undefined
      };
      this.batchData = [];
      this.tableData = [];
      this.fileList = [];
      this.$parent.selectedRows = []
      this.$parent.selectedRowKeys = []
      this.$refs.fileUpload.setFileList();
    },
    beforeFileUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    // 校验罚息利率输入0.0001 ~ 1
    overdueRateCheck1(rule, value, cbfn) {
      if (!this.otherform.overdueRateVal) {
        cbfn('请输入罚息利率');
      } else if (+this.otherform.overdueRateVal >= 0 && +this.otherform.overdueRateVal <= 1) {
        cbfn();
        return true;
      } else {
        cbfn('罚息利率为0 ~ 1 的数字');
      }
    },
    // 校验日期格式 - 支持 YYYY-MM-DD 和 YYYY-MM-DD HH:mm:ss 格式
    validateDateFormat(dateStr) {
      // 支持的日期格式
      const datePatterns = [
        /^\d{4}-\d{2}-\d{2}$/,  // YYYY-MM-DD
        /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/  // YYYY-MM-DD HH:mm:ss
      ];
      
      // 检查是否为空
      if (!dateStr) {
        return { valid: false, message: '日期不能为空' };
      }
      
      // 检查格式
      const isMatchFormat = datePatterns.some(pattern => pattern.test(dateStr));
      if (!isMatchFormat) {
        return { valid: false, message: `日期格式不正确："${dateStr}"，请使用 YYYY-MM-DD 或 YYYY-MM-DD HH:mm:ss 格式` };
      }
      
      // 提取日期部分进行验证
      const datePart = dateStr.split(/\s+/)[0]; // 提取 YYYY-MM-DD 部分
      const date = new Date(datePart);
      
      if (isNaN(date.getTime())) {
        return { valid: false, message: `日期无效："${dateStr}"，请检查日期是否正确` };
      }
      
      // 验证转换后的日期是否与原始字符串一致（防止 2024-02-30 这类日期被自动修正）
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const normalizedDate = `${year}-${month}-${day}`;
      
      if (normalizedDate !== datePart) {
        return { valid: false, message: `日期无效："${dateStr}"，正确的格式应为 "${normalizedDate}"` };
      }
      
      return { valid: true, message: '' };
    },
    // 校验导入数据中的日期字段
    validateImportedData(data) {
      const errors = [];
      
      if (!data || !Array.isArray(data)) {
        return errors;
      }
      
      data.forEach((item, index) => {
        // 校验申请日期 startDay
        if (item.startDay) {
          const startDayResult = this.validateDateFormat(item.startDay);
          if (!startDayResult.valid) {
            errors.push(`第 ${index + 1} 行 - 申请日期：${startDayResult.message}`);
          }
        }
        
        // 校验到期日期 exDay
        if (item.exDay) {
          const exDayResult = this.validateDateFormat(item.exDay);
          if (!exDayResult.valid) {
            errors.push(`第 ${index + 1} 行 - 到期日期：${exDayResult.message}`);
          }
        }
      });
      
      return errors;
    },
    handleFileUpload() {
      const formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append('importFile', file);
      });

      this.uploading = true;
      if (!this.isShow || !this.isShow.length) {
        this.axios({
          url: '/user/gold/grt/batch/todoImport',
          data: formData,
          isTransform: false
        })
          .then((res) => {
            this.uploading = false;
            if (res.data) {
              // 校验日期格式
              const dateErrors = this.validateImportedData(res.data);
              if (dateErrors.length > 0) {
                this.$message.error('日期格式错误，请使用 YYYY-MM-DD 或 YYYY-MM-DD HH:mm:ss 格式');
                this.fileList = [];
                this.tableData = [];
                return;
              }
              
              this.tableData = res.data;
              this.pagination.total = res.data.length;
            }
          })
          .catch((err) => {
            this.fileList = [];
            this.uploading = false;
            // 显示后端返回的错误信息
            const errorMsg = (err.response && err.response.data && err.response.data.message) || err.message || '导入失败，请检查文件格式是否正确';
            this.$message.error(errorMsg);
          });
      } else {
        formData.append('sellrName', this.isShow[0].sellrName);
        formData.append('sellrOrgCode', this.isShow[0].sellrOrgCode);
        this.axios({
          url: '/user/gold/grt/invoice/batch/todoImport',
          data: formData,
          isTransform: false
        })
          .then((res) => {
            this.uploading = false;
            if (res.data) {
              // 校验日期格式
              const dateErrors = this.validateImportedData(res.data);
              if (dateErrors.length > 0) {
                this.$message.error('日期格式错误，请使用 YYYY-MM-DD 或 YYYY-MM-DD HH:mm:ss 格式');
                this.fileList = [];
                this.tableData = [];
                return;
              }
              
              this.tableData = res.data;
              this.pagination.total = res.data.length;
            }
          })
          .catch((err) => {
            this.fileList = [];
            this.uploading = false;
            // 显示后端返回的错误信息
            const errorMsg = (err.response && err.response.data && err.response.data.message) || err.message || '导入失败，请检查文件格式是否正确';
            this.$message.error(errorMsg);
          });
      }
    },
    handleImportTableData() {
      console.log("%c Line:879 🍒 this.tableData", "color:#2eafb0", this.tableData);
      this.importloading = true;
      if (!this.isShow || !this.isShow.length) {
        this.axios({
          url: '/user/gold/grt/batch/handleImportData',
          data: { goldenOpenVOList: JSON.stringify(this.tableData) }
        })
          .then((res) => {
            if (res.data) {
              this.batchData = res.data.map((item) => {
                item.fileNm = item.fileList && item.fileList.length > 0 ? item.fileList.map((it) => it.fileNm).join(',') : '';

                return item;
              });
              this.pagination2.total = res.data.length;
              this.importloading = false;
            }
          })
          .catch((err) => {
            this.importloading = false;
          });
      } else {
        console.log(this.fulfilselectedRowKeys, 123);

        this.axios({
          url: '/user/gold/grt/invoice/batch/handleImportData',
          data: { goldenOpenVOList: JSON.stringify(this.tableData), cyCode: this.isShow[0].cyCode }
        })
          .then((res) => {
            if (res.data) {
              this.batchData = res.data
              this.pagination2.total = res.data.length;
              this.importloading = false;
              this.tableData = []
            }
          })
          .catch((err) => {
            this.importloading = false;
          });
      }
    },
    saveBatchData(btn) {
      if (!this.isShow || !this.isShow.length) {
        this.axios({
          url: '/user/gold/grt/batch/saveBatchData',
          data: { goldenOpenVOList: JSON.stringify(this.batchData) }
        })
          .then((res) => {
            btn.closeLoad();
            if (res.status === 200) {
              this.close();
            }
          })
          .catch((err) => {
            btn.closeLoad();
          });
      } else {
        this.axios({
          url: '/user/gold/grt/invoice/doSaveGuarantee',
          data: { list: JSON.stringify(this.batchData) }
        })
          .then((res) => {
            btn.closeLoad();
            if (res.status === 200) {
              this.close();
            }
          })
          .catch((err) => {
            btn.closeLoad();
          });
      }
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        mdlId: 'payable'
      };
      fileSaveAPI(param)
        .then((res) => {
          this.uploading = false;
          this.pageData.fileId = res.data.fileId;
          this.pageData.file = data;
          this.$refs.ruleForm && this.$refs.ruleForm.validateField('fileId');
        })
        .catch((err) => {
          this.uploading = false;
          console.log(err);
        });
    },
    fileViewOpen() {
      //  getLetterofCommitment(params).then(res => {
      //     this.artcCntnt = res.data;
      //     this.$refs.fileView.open();
      //   })
    },
    uploadOk(resList) {
      this.fileSave(resList[0]);
    },
    uploadOkCopy(fileObj) {
      console.log('%c Line:931 🥐 fileObj', 'color:#42b983', fileObj);
      this.fileZipObj = fileObj;
    },
    uploadOkZip(resList) {
      this.uploadOkZipArray = [];
      resList.forEach((item) => {
        let tblBlId = this.utils.guid(32, 16);
        let fileInfo = item.split('/');
        let fileNm = fileInfo[fileInfo.length - 1];
        let fileExpdNm = fileNm ? fileNm.split('.')[1] : 'zip';
        console.log('%c Line:942 🍩 fileExpdNm', 'color:#e41a6a', fileExpdNm);
        const param = {
          fileNm: fileNm,
          fileSize: this.fileZipObj.size,
          fileRte: item,
          fileExpdNm: '.' + fileExpdNm,
          tblBlId: tblBlId,
          mdlId: '10068',
          fileTpCd: '5',
          fileSubTpCd: 0
        };
        fileSaveAPI(param)
          .then((res) => {
            this.tableData.forEach((it) => {
              console.log('%c Line:965 🌶 fileNm.includes(it.fileNm)', 'color:#42b983', fileNm.includes(it.gldId));

              if (fileNm.includes(it.gldId)) {
                it.fileList = it.fileList ? it.fileList : [];
                it.fileList.push({
                  ...param,
                  id: res.data.id,
                  fileId: res.data.fileId,
                  status: 'done'
                });
                it.fileNm = it.fileList && it.fileList.length > 0 ? it.fileList.map((it1) => it1.fileNm).join(',') : '';

              }
            });
            this.$forceUpdate();

          })
          .catch((err) => {
            this.uploading = false;
            console.log(err);
          });
      });
      // if (resList[0].fileExpdNm === 'zip') {
      //   this.uploadOkZipArray.forEach((item) => {
      //     this.fileSave(item);
      //   });
      // }
      // this.fileSave(resList[0]);
    },
    batchOpening(resList) {
      this.fileIdsArr = [];
      this.fileListArr = [];
      this.fileIdsArr = resList.map((item) => {
        return item.fileId;
      });
      this.fileListArr = resList;
    },
    openFileTable(record) {
      this.fileTableData = record.fileList;
      this.fileTableVisible = true;
    },

    down(item) {
      const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
      window.open(`${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`, '_blank');
    },
    handlePreview(data) {
      if (data.fileNm.includes('.ZIP') || data.fileNm.includes('.zip')) {
        this.$message.warning('压缩包不支持预览');
        return;
      }
      if (data.fileNm.includes('.pdf') || data.fileNm.includes('.PDF')) {
        this.lookFile(data);
      } else {
        this.previewImage = '/gb-bigtree-file/download/fileDownload/install' + data.fileRte + '/' + data.fileNm;
        this.previewVisible = true;
      }
    },
    async lookFile(row) {
      console.log('%c Line:176 🍆 row', 'color:#93c0a4', row);
      const pdfjsLib = await import('pdfjs-dist/build/pdf');
      const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      console.log('%c Line:425 🍷 this.pdfUrl', 'color:#e41a6a', process.env);
      const pdfUrl = '/gb-bigtree-file/download/fileDownload/install' + row.fileRte + '/' + row.name;
      this.pdfVisible = true;

      // 加载 PDF
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;

      // 渲染第一页
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      this.$refs.pdfContainer.innerHTML = '';
      this.$refs.pdfContainer.appendChild(canvas);

      await page.render({
        canvasContext: context,
        viewport
      }).promise;
    },
    // 删除文件
    removeOk() {
      this.pageData.file = null;
      this.pageData.fileId = undefined;
    },
    // 计算表格勾选合计
    totalPayable(list, key = 'gldAmt') {
      return list.reduce((acc, rec) => {
        return acc + (+rec[key] || 0);
      }, 0);
    },
    //选择附近
    chooseFile(row) {
      // this.fileTableData = row.fileList;
      this.fulfilVisible = true;
      console.log(this.isShow, 'this.isShow');
      this.rowData = row
      if (!this.isShow || !this.isShow.length) {
        this.$message.warning('缺少必要的企业信息');
        return;
      }
      invoicegetVoucherList({ openType: '1', cyCode: this.isShow[0].cyCode }).then((res) => {
        if (res.data) {
          this.fulfiltableData = res.data;
        }
      })
        .catch((err) => { });
    },
    onSelect(selectedRows, checked) {
      if (checked) {
        this.fulfilselectedRowKeys.push(selectedRows.id);
        this.fulfilselectedRows.push(selectedRows);
      } else {
        let index = this.fulfilselectedRowKeys.indexOf(selectedRows.id);
        this.fulfilselectedRowKeys.splice(index, 1);
        this.fulfilselectedRows.splice(index, 1);
      }
      console.log(this.fulfilselectedRowKeys, this.fulfilselectedRows);
    },
    // 表格选择处理
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        for (let i = 0; i < selectedRows.length; i++) {
          if (this.fulfilselectedRowKeys.indexOf(selectedRows[i].id) == -1) {
            this.fulfilselectedRowKeys.push(selectedRows[i].id);
            this.fulfilselectedRows.push(selectedRows[i]);
          }
        }
      } else {
        for (let i = 0; i < changeRows.length; i++) {
          let index = this.fulfilselectedRowKeys.indexOf(changeRows[i].id);
          if (index > -1) {
            this.fulfilselectedRowKeys.splice(index, 1);
            this.fulfilselectedRows.splice(index, 1);
          }
        }
      }
      console.log(this.fulfilselectedRowKeys, this.fulfilselectedRows, changeRows);

    },
    getTableList() {
      // this.voucherCodeValidate = false;
      if (!this.fulfilData.voucherCode) return;
      let inItem = this.fulfiltableData.find((i) => i.voucherCode == this.fulfilData.voucherCode);
      if (inItem) {
        return;
      }
      this.tableLoading = true;
      invoicegetVoucherList({
        voucherCode: this.fulfilData.voucherCode,
        openType: '1',
      })
        .then((res) => {
          this.tableLoading = false;
          this.fulfiltableData = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.tableLoading = false;
        });
    },
    fulfilclose() {
      this.fulfilData = {
        voucherCode: "",
        documentType: "",
      };
      this.fulfiltableData = [];
      this.$refs.fulfilForm && this.$refs.fulfilForm.resetFields();
      this.fulfilVisible = false;
    },
    toGldDetail(row) {
      this.MENUAPI.goToOneTab({
        path: 'bill-payment/payment/detail/' + way + '/' + data.gldId + '/' + 3,
        query: {
          fromPath: 'bill-payment/payment'
        }
      });
    },
    downloadFile(item) {
      const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
      window.open(`${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`, '_blank');
    },
    handlefulfilOk() {
      const currentRow = this.tableData.find(el => el.gldId === this.rowData.gldId);

      if (currentRow) {
        // 只给当前行赋值
        currentRow.voucherIds = JSON.stringify(this.fulfilselectedRowKeys);
        // 获取新选中的file数组
        const newFiles = this.fulfilselectedRows.map(item => item.file.fileNm);
        // 合并现有fileIds和新文件，并去重
        const existingFiles = currentRow.fileNm || [];
        currentRow.fileNm = [...new Set([...existingFiles, ...newFiles])].join(',')
        console.log(currentRow.fileNm);
        // 强制重新渲染表格
        this.tableData = [...this.tableData];
      }
      console.log(this.tableData, 'this.tableData');
      this.fulfilselectedRowKeys = [];
      this.fulfilselectedRows = [];
      this.fulfilVisible = false;

    }
  },
  watch: {
    isLRP1(newVal) {
      if (newVal) {
        let num = parseInt((this.LRP / 360) * 10000) / 10000;
        if (num >= 0.0001) {
          this.otherform.overdueRateVal = (num + 0.0001).toFixed(4);
        } else {
          this.otherform.overdueRateVal = 0.0001;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/batchInvoicing.vue